<template>
    <div v-if="task.output">
        <div class="tasks-bar-buttons">
            <a v-if="task.output.csvUrl" :href="task.output.csvUrl" target="_blank" @click="done()">
                <i class="fa fa-file-text"></i>
                CSV
            </a>
            <a v-if="task.output.xlsxUrl" :href="task.output.xlsxUrl" target="_blank" v-tooltip title="Excel 2007 ou superior" @click="done()">
                <i class="fa fa-file-excel-o"></i>
                Excel
            </a>
            <a v-if="task.output.jsonUrl" :href="task.output.jsonUrl" target="_blank" @click="done()">
                <i class="fa fa-file-text"></i>
                JSON
            </a>
            <a v-if="task.output.xmlUrl" :href="task.output.xmlUrl" target="_blank" @click="done()">
                <i class="fa fa-file-text"></i>
                XML
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            },
            done: {
                type: Function
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ExportPropertiesV1.vue?4e4cb2cb